import clsx from 'clsx';
import { useMemo } from 'react';

import { Dropdown } from '~components/generic/elements/Dropdown';
import { useMamAssets } from '~services/api/hooks/mam-assets.hooks';
import { getRelatedEntityIds } from '~services/entity-helpers';
import { splitToUniqueInt } from '~utils/split';
import { CmsAssets } from './CmsAssets';
import { MamAssets } from './MamAssets';
import styles from './ModuleAttachments.module.css';

export type ModuleAttachmentsProps = {
  data: ModuleEntity;
};

export const ModuleAttachments = ({ data }: ModuleAttachmentsProps) => {
  const cmsAssetIds = getRelatedEntityIds(data, 'field_assets');
  const mamAssetIdsRaw = data.attributes.field_mam_assets || '';
  const mamAssetIds = useMemo(() => splitToUniqueInt(mamAssetIdsRaw), [mamAssetIdsRaw]);
  const { data: mamAssets } = useMamAssets(mamAssetIds);
  const countAssets = (cmsAssetIds?.length || 0) + (mamAssets?.length || 0);

  if (countAssets === 0) {
    return null;
  }

  return (
    <div className="c-module__attachments">
      <Dropdown
        className="c-dropdown--relative-mobile"
        buttonLabel={`${countAssets}`}
        buttonClassName={clsx('c-button c-button--light', styles.dropdown)}
        iconName="download-cloud"
        iconClassName="u-absolute-size-lg"
      >
        <ul className={clsx(styles.list, 'asset-list')}>
          <MamAssets assetIds={mamAssetIds} />
          <CmsAssets assetIds={cmsAssetIds} />
        </ul>
      </Dropdown>
    </div>
  );
};

export default ModuleAttachments;
